import { ACORNS_HELLO_FLOW, CURRENT_SIGN_UP_SCREEN_KEY } from 'app-constants'
import { getPageViewEvent } from 'utils/analytics'
import { FlowRoute } from 'utils/FlowProvider/types'
import { getTierKey, getTierPrice } from 'utils/TieredRegistration/utils'

export const getAccessibilityEventData = () => {
  const onPasswordSignUpScreen = sessionStorage.getItem(CURRENT_SIGN_UP_SCREEN_KEY) === 'password'
  if (location.pathname === FlowRoute.Signup && onPasswordSignUpScreen) {
    return {
      object_name: 'accessibility',
      screen: 'registrationCreateAccountPassword',
      screen_name: 'registrationCreateAccountPassword',
    }
  }

  const flow = window.localStorage.getItem(ACORNS_HELLO_FLOW)
  const pageViewEvent = getPageViewEvent(location, flow)

  const tierData: { tierKey?: string; tierPrice?: number } = {}
  if (getTierKey()) tierData.tierKey = getTierKey()
  if (getTierPrice()) tierData.tierPrice = getTierPrice()

  return {
    ...tierData,
    funnel: flow,
    screen: location.pathname, // pageViewEvent should override this
    screen_name: location.pathname, // pageViewEvent should override this
    ...pageViewEvent,
    object_name: 'accessibility',
  }
}
